import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-details-panel',
  templateUrl: './details-panel.component.html',
  styleUrls: ['./details-panel.component.scss']
})
export class DetailsPanelComponent implements OnInit {

  @Input() items: {
    label: string,
    value: string | number
  }[];
  @Input() columns: number;
  @Input() rows: number;

  constructor() { }

  ngOnInit(): void {
  }

}
